const LAST_PATH_KEY = "lastPath";

const ADMIN_FALLBACK_PATH = "/calendario";
const CLEANING_FALLBACK_PATH = "/limpieza-diaria";

const REMEMBERABLE_PATHS = new Set([
  "/calendario",
  "/reservas",
  "/estadisticas",
  "/departamentos",
  "/estacionamientos",
  "/clientes",
  "/logs",
  "/inventario",
  "/limpieza",
  "/limpieza-diaria",
  "/correo",
]);

const normalizePathname = (pathname: string) => {
  const normalized = pathname.replace(/\/+$/, "");
  return normalized || "/";
};

export const isKnownAppPath = (pathname: string) => {
  const normalized = normalizePathname(pathname);
  return REMEMBERABLE_PATHS.has(normalized) || /^\/inventario\/[^/]+$/.test(normalized);
};

const canUsePathForRole = (pathname: string, role?: string | null) => {
  const normalized = normalizePathname(pathname);
  if (!isKnownAppPath(normalized)) return false;
  if (role === "limpieza") return normalized === CLEANING_FALLBACK_PATH;
  if (normalized === CLEANING_FALLBACK_PATH) return false;
  if (normalized === "/logs") return role === "super_admin" || role === "admin";
  return true;
};

const parseStoredPath = (raw: string | null) => {
  if (!raw) return null;
  try {
    const origin = window.location.origin;
    const url = new URL(raw, origin);
    if (url.origin !== origin) return null;
    return {
      pathname: normalizePathname(url.pathname),
      search: url.search,
      hash: url.hash,
    };
  } catch {
    return null;
  }
};

export const rememberLastPath = (location: {
  pathname: string;
  search?: string;
  hash?: string;
}) => {
  const pathname = normalizePathname(location.pathname);
  if (!isKnownAppPath(pathname)) return;

  localStorage.setItem(
    LAST_PATH_KEY,
    `${pathname}${location.search || ""}${location.hash || ""}`
  );
};

export const getSafeLastPath = (role?: string | null) => {
  if (role === "limpieza") return CLEANING_FALLBACK_PATH;

  const stored = parseStoredPath(localStorage.getItem(LAST_PATH_KEY));
  if (stored && canUsePathForRole(stored.pathname, role)) {
    return `${stored.pathname}${stored.search}${stored.hash}`;
  }

  return ADMIN_FALLBACK_PATH;
};
